import React from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  SearchBarComponent,
} from "../../../component/atom";
import {QuizMarkCard,} from "../../../component/molecule";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { Actions } from "../../../core/modules/Actions";
import _ from "lodash";
import { getText } from "../../../core/Constant";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";

const QuizStartScreen = ({
  stdquizList,
  stdgetQuizlist,
  quizStateChange,
  courseList,
  getCourseList,
  getStdCourseList,
  stdCourseList,
}) => {
  const navigate = useNavigate();
  const [filteredValue, setFilteredValue] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [newcourseList, setCourseList] = useState([]);
  const [course, setCourse] = useState("");

  const navigateToQuizMain = (value) => {
    // Reset quiz state before starting a new attempt
    quizStateChange(false);
    navigate("/quiz-main", {
      state: { quizData: value },
    });
  };

  const navigateToAttempts = (value) => {
    navigate("/quiz-attempt", { state: { quiz: value } });
  };

  useEffect(() => {
    quizStateChange(false);
  }, []);

  useEffect(() => {
    getCourseList();
  }, []);

  useEffect(() => {
    getStdCourseList();
  }, []);

  useEffect(() => {
    const list = _.map(stdCourseList, (item, index) => {
      return {
        id: item.course_id,
        course_id: item.course_id,
        name: item.course_name,
      };
    });
    setCourseList(list);
    const defaultCourse = list[0]?.id;
    setCourse(defaultCourse);
    if (defaultCourse) {
      stdgetQuizlist(defaultCourse);
    }
  }, [stdCourseList]);

  const onCourseChange = (e) => {
    const Selectedvalue = getText(e);
    console.log(Selectedvalue)
    setCourse(Selectedvalue);
    localStorage.setItem("firstcourse", Selectedvalue);
    if (
      Selectedvalue !== null ||
      Selectedvalue !== undefined ||
      Selectedvalue !== ""
    ) {
      stdgetQuizlist(Selectedvalue);
      quizStateChange(false);
    }
  };

  useEffect(() => {
    setFilteredValue(stdquizList);
  }, [stdquizList]);

  useEffect(() => { }, [searchInput]);

  const handleSearch = (searchedValue) => {
    setSearchInput(searchedValue);

    const list = _(stdquizList)
      .filter((item) =>
        item?.name?.toLowerCase().includes(searchedValue?.toLowerCase())
      )
      .value();
    setFilteredValue(list);
  };

  return (
    <>
      <Grid className="main-screen-container" container flexDirection={"column"} rowSpacing={1} mt={2}>
        <Grid item>
          <Grid container justifyContent={"space-between"}>
            <Grid item>
              <HeadingComponent
                fontweigth={600}
                size={"26px"}
                color={"#2d3945"}
                text={"Quizzes"}
              />
            </Grid>
            <Grid item>
              <Grid container alignItems={"center"}>
                <Grid item>
                  <DropDownComponent
                    isShowPlaceholder={true}
                    isShowZero={newcourseList.length > 0 ? false : true}
                    initialValue="Select Course"
                    onchange={onCourseChange}
                    radius={"15px"}
                    list={newcourseList}
                    selectedValue={course}
                  />
                </Grid>
                <Grid item>
                  <SearchBarComponent
                    value={searchInput}
                    onchange={(e) => handleSearch(getText(e))}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {filteredValue.length === 0 ? (
          <>
            <p style={{ marginTop: "15px" }} className="week-text">
              No Quizes found
            </p>
            <p style={{ marginTop: "1%" }} className="week-text">
              Please Select Your Course
            </p>
          </>
        ) : (
          <></>
        )}

        <Grid container sx={{ gap: 2 }}>
          {filteredValue?.map((value, count) => {
            let leftattempts =
              value.no_of_attempts - value.quiz_status[0].attempts;

            let isAttempt =
              value.quiz_status[0].attempts > 0 &&
              value.no_of_attempts - value.quiz_status[0].attempts > 0;
            let status = value.quiz_status[0].attempts == 0;

            return (
              <Grid key={'quiz' + count} item>
                <QuizMarkCard
                  title={value?.name}
                  status={status}
                  onViewAttempsts={() => navigateToAttempts(value)}
                  attempts={leftattempts}
                  duration={value?.duration}
                  week={value?.week}
                  date={""}
                  onViewQuiz={() => navigateToQuizMain(value)}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default connect(
  (state) => ({
    stdquizList: state.quizes.get("stdquizList"),
    courseList: state.course.get("commonCourseList"),
    stdCourseList: state.course.get("stdCourseList"),
  }),
  {
    stdgetQuizlist: Actions.quizes.stdgetQuizlist,
    quizStateChange: Actions.quizes.quizStateChange,
    getCourseList: Actions.course.getCourseList,
    getStdCourseList: Actions.course.getStdCourseList,
  }
)(QuizStartScreen);